import { useFormik } from "formik";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import documentValidation from "../utils/documentValidation";
import Modal from "@mui/material/Modal";
import { setDocument } from "../../../../store/slices/applicationManagement/managementSlice";
import { DOCUMENT_CRUD_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { usePostDocumentTypeMutation } from "../../../../store";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";

const DocumentForm = () => {
  const dispatch = useDispatch();
  const { document } = useSelector((state) => state.managementSlice);
  const { documentCRUDDialogOpen } = useSelector((state) => state.dialogSlice);
  const handleClose = () => {
    dispatch(setDocument(null));
    dispatch(closeDialog(DOCUMENT_CRUD_DIALOG));
  };
  const [postDocument, { isLoading }] = usePostDocumentTypeMutation();
  const formik = useFormik({
    initialValues: {
      id: document?.id ?? 0,
      name: document?.name ?? "",
    },
    validationSchema: documentValidation,
    enableReinitialize: true,
    onSubmit: async (values, bag) => {
      try {
        postDocument({
          id: formik.values.id,
          name: formik.values.name,
        }).then((response) => {
          if (!response.data.isSuccess) {
            dispatch(openErrorToast(response.data.message));
          } else {
            dispatch(openSuccessToast("Belge Kaydedildi !"));
            handleClose();
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });

  return (
    <Modal
      open={documentCRUDDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 8,
          p: 4,
          minWidth: 320,
          width: 370,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            color: "primary.main",
            textAlign: "center",
          }}
        >
          Belge Kaydet
        </Typography>
        <Stack spacing={2}>
          <TextField
            label="Belge Adı"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            fullWidth
            autoFocus
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700, mt: 2 }}
          >
            Kaydet
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default DocumentForm;
